import { useState } from "react";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { atualizarCotaUsuario } from "../../ViewGerenciarPropriedadeUsuario/services/atualizarCotaUsuarioService";

export const useAtualizarValor = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const resetError = () => setError(null); // Função para resetar o erro
  const resetSuccess = () => setSuccess(null); // Função para resetar o sucesso

  const atualizar = async (
    cotaUsuarioId: number,
    anuncioData: Partial<CotaUsuario>
  ) => {
    setIsLoading(true);
    try {
      const data = await atualizarCotaUsuario(cotaUsuarioId, anuncioData);
      if (data) {
        setSuccess(`Detalhes alterados com suceso!`);
        return true;
      } else {
        setError(
          `Não foi possível atualizar os detalhes deste anúncio. Por favor tente novamente!`
        );
        return false;
      }
    } catch (err) {
      setError(`Ocorreu um erro: ${err.message}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizar, isLoading, success, error, resetError, resetSuccess };
};
